/**
 * Deletes a cookie using the CookieStore API.
 * Fallback to overriding the cookie on the document if CookieStore is not available.
 */
export const deleteCookie = async (name: string, path: string) => {
  const domain = new URL(path).hostname;

  if ('cookieStore' in window) {
    const { cookieStore } = window as { cookieStore: CookieStore };

    return cookieStore.delete({ name, domain });
  }

  // eslint-disable-next-line functional/immutable-data, unicorn/no-document-cookie
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/;`;
};

type CookieStore = {
  delete(options?: CookieDeleteOptions): Promise<void>;
};

type CookieDeleteOptions = {
  name: string;
  domain?: string;
};
